// src/data/translations.js
// ─── Copy de la Studio Edition ───
// Vive aparte del copy antiguo para poder ajustarlo sin tocar lo demás.
// TODO(Juan): el lede de About sigue siendo un borrador.
const studioEn = {
  signature: "Code by",
  nav_home: "Home",
  nav_work: "Work",
  nav_about: "About",
  nav_contact: "Contact",
  menu: "Open menu",
  menu_label: "Menu",
  close: "Close menu",
  socials: "Socials",
  navigation: "Navigation",
  language: "Language",
  get_in_touch: "Get in touch",
  based_in: "Based in",
  version: "Version",
  local_time: "Local time",

  available: "Available for work",
  hero_line_1: "Full-Stack",
  hero_line_2: "Developer",
  located: "Located in Bogotá, D.C Colombia",
  located_l1: "Located in",
  located_l2: "Bogotá, D.C",
  located_l3: "Colombia",
  scroll: "Scroll",
  statement:
    "I turn scattered data into systems people actually use: analysis, report automation, AI models, applications — and the design that holds them together.",
  about_short:
    "Full stack developer working across web, mobile and AI. I care about systems that hold up after launch, not just demos that look good on a slide.",
  about_link: "About me",
  recent_work: "Recent work",
  more_work: "All work",
  cta_title: "Let's work together",

  work_title: "Work",
  cat_all: "All",
  cat_web: "Web",
  cat_mobile: "Mobile",
  cat_ml: "Machine learning",

  meta_role: "Role / Services",
  meta_credits: "Credits",
  meta_where: "Location & Year",
  meta_stack: "Stack",
  demo_access: "Demo access",
  demo_user: "User",
  demo_pass: "Password",
  live_site: "Live site",
  next_case: "Next project",
  all_work: "All work",

  about_title: "About",
  about_lede:
    "I am a developer from Colombia. I work across the full stack and I like the part of the job nobody posts about: making the thing actually work.",
  experience: "Experience",
  stack: "Stack",
  education: "Education",
  resume: "Résumé",

  contact_title: "Contact",
  send: "Send",
  send_error: "Something went wrong. Write me directly instead.",
};

const studioEs = {
  signature: "Código por",
  nav_home: "Inicio",
  nav_work: "Proyectos",
  nav_about: "Acerca",
  nav_contact: "Contacto",
  menu: "Abrir menú",
  menu_label: "Menú",
  close: "Cerrar menú",
  socials: "Redes",
  navigation: "Navegación",
  language: "Idioma",
  get_in_touch: "Escríbeme",
  based_in: "Ubicado en",
  version: "Versión",
  local_time: "Hora local",

  available: "Disponible para trabajar",
  hero_line_1: "Desarrollador",
  hero_line_2: "Full-Stack",
  located: "Ubicado en Bogotá, D.C Colombia",
  located_l1: "Ubicado en",
  located_l2: "Bogotá, D.C",
  located_l3: "Colombia",
  scroll: "Scroll",
  statement:
    "Convierto datos dispersos en sistemas que se usan a diario: análisis, automatización de informes, modelos de IA, aplicaciones — y el diseño que los sostiene.",
  about_short:
    "Desarrollador full stack entre web, móvil e IA. Me importa que los sistemas aguanten después del lanzamiento, no que se vean bien en una diapositiva.",
  about_link: "Sobre mí",
  recent_work: "Trabajo reciente",
  more_work: "Todo el trabajo",
  cta_title: "Trabajemos juntos",

  work_title: "Proyectos",
  cat_all: "Todos",
  cat_web: "Web",
  cat_mobile: "Móvil",
  cat_ml: "Machine learning",

  meta_role: "Rol / Servicios",
  meta_credits: "Créditos",
  meta_where: "Lugar & Año",
  meta_stack: "Stack",
  demo_access: "Acceso de prueba",
  demo_user: "Usuario",
  demo_pass: "Contraseña",
  live_site: "Ver sitio",
  next_case: "Siguiente proyecto",
  all_work: "Todo el trabajo",

  about_title: "Acerca",
  about_lede:
    "Soy desarrollador, de Colombia. Trabajo en todo el stack y me gusta la parte del oficio que nadie publica: que la cosa funcione de verdad.",
  experience: "Experiencia",
  stack: "Stack",
  education: "Educación",
  resume: "Hoja de vida",

  contact_title: "Contacto",
  send: "Enviar",
  send_error: "Algo falló. Escríbeme directamente.",
};

export const translations = {
  en: {
    studio: studioEn,
    about: "About",
    skills: "Skills",
    experience: "Experience",
    projects: "Projects",
    education: "Education",
    contact: "Contact",
    contact_desc: "Feel free to reach out if you have any questions or opportunities.",
    contact_info_title: "Let's build something together",
    contact_info_text: "Open to full-time roles, freelance projects, and interesting collaborations. I usually reply within 24 hours.",
    contact_available: "Available for work",
    contact_connect: "Connect with me",
    contact_form_title: "Send me an email",
    contact_email_placeholder: "you@email.com",
    contact_email_error: "Please enter a valid email address.",
    contact_name_label: "Name",
    contact_name_placeholder: "Your full name",
    contact_subject_label: "Subject",
    contact_subject_placeholder: "How can I help you?",
    contact_message_label: "Message",
    contact_message_placeholder: "Tell me about your project...",
    contact_sending: "Sending...",
    contact_send: "Send Message",
    contact_success: "Email sent successfully!",
    hi: "Hi, I am",
    i_am_a: "I am a",
    view_cv: "View CV",
    // Bio translations
    bio_description: "I am a motivated and versatile person, always ready to face new challenges. Passionate about learning, I am dedicated to delivering high-quality results. I possess a positive attitude and a growth mindset, which constantly drives me to improve and develop both personally and professionally.",
    // Skills translations
    technical_skills: "Technical Skills",
    soft_skills: "Soft Skills",
    skill_desc: "These are some of the skills I have been working on and developing over the past 3 years.",
    skill_1: "Ability to quickly and effectively learn new languages.",
    skill_2: "Experience with development tools, frameworks, APIs, and libraries.",
    skill_3: "Understanding software architecture and design effectively.",
    skill_4: "Ability to understand and use third-party APIs.",
    skill_5: "Knowledge of databases and use of different tools.",
    soft_skill_1: "Effective and clear communication skills.",
    soft_skill_2: "Ability to adapt to changes and solve problems.",
    soft_skill_3: "Creativity and ability to think of innovative and effective solutions.",
    soft_skill_4: "Ease of working in teams and leading work teams.",
    soft_skill_5: "Self-management and ability to work independently.",
    // Frameworks translations
    frameworks_title: "Technologies",
    frameworks_desc: "These are some of the frameworks and programming languages I have been working on and developing over the past 3 years.",
    languages: "Languages",
    frontend: "Frontend",
    backend: "Backend",
    databases: "Databases",
    mobile: "Mobile",
    ai: "AI & Automation",
    devops: "DevOps & Cloud",
    tools: "Tools",
    // Roles translations
    full_stack_developer: "Full-Stack Developer",
    mobile_developer: "Mobile Developer",
    ui_ux_designer: "UI/UX Designer",
    ai_developer: "AI Developer",
    // Experience translations
    experience_title: "Experience",
    experience_desc: "I am a Software Development Technologist with a solid academic foundation and a great interest in applying my knowledge in the development of innovative technological solutions. I am starting my professional career and looking for opportunities to contribute to practical projects, where I can continue learning and developing while adding value with my skills in programming, software design, and problem-solving.",
    experiences: [
    {
      id: 0,
      role: "Web Designer, Frontend Developer",
      company: "InnovaHogarTV",
      date: "Mar 1, 2021 - May 30, 2022",
      desc: "• Developed an e-commerce website using React JS, HTML, CSS, and JavaScript for a home products company. Focused on improving user experience by creating a highly interactive and responsive interface. Users could easily explore products and directly contact the company through intuitive navigation and optimized UI components.",
      skills: ["ReactJs", "NodeJs", "HTML", "CSS", "JavaScript"],
    },
  
    {
      id: 1,
      role: "Full-Stack Developer",
      company: "Snake Meta",
      date: "Nov 10, 2023 - Nov 25, 2024",
      desc: "• Enhanced user experiences using Flutter and Hive for offline-first functionality and local storage. Built JWT authentication and seamless REST API integrations using FastAPI, Flask, and Python. Exported the application to Android and iOS while maintaining updated dependencies and integrating SQLAlchemy with SQLite for database management. Implemented geolocation features using the Google Maps API.",
      skills: [
        "Python",
        "Flask",
        "FastAPI",
        "Flutter",
        "SQLAlchemy",
        "Hive",
        "Firebase",
        "Google Maps API",
      ],
    },
  
    {
      id: 2,
      role: "Mobile Developer, Software Debugger & Architecture",
      company: "Aktua",
      date: "Feb 13, 2024 - May 18, 2024",
      desc: "• Developed a PWA using Python, implementing Poetry, Uvicorn, Flask, and FastAPI. Managed PostgreSQL database queries with SQLAlchemy and designed high-level software architecture alongside UI prototypes using ProtoPie Cloud. Built secure and efficient backend endpoints with JWT authentication and optimized API performance by reducing unnecessary requests by 20%. Containerized the application using Docker to streamline deployment and automation workflows.",
      skills: [
        "Docker",
        "Python",
        "Flask",
        "SQLAlchemy",
        "FastAPI",
        "PostgreSQL",
        "ProtoPie",
        "Flutter",
        "JWT",
      ],
    },
  
    {
      id: 3,
      role: "Full-Stack Developer",
      company: "Bodytech and Athletic Gym",
      date: "Jan 15, 2024 - Feb 10, 2025",
      desc: "• Collaborated on the development and optimization of modern web interfaces focused on user experience and performance. Worked with React, TypeScript, and Tailwind CSS to build reusable components and responsive designs. Integrated frontend services with REST APIs and contributed to performance optimization, accessibility improvements, and visually engaging interfaces for fitness and wellness platforms.",
      skills: [
        "React",
        "TypeScript",
        "Tailwind CSS",
        "JavaScript",
        "REST API",
        "Figma",
        "Responsive Design",
      ],
    },
  
    {
      id: 4,
      role: "Android Developer",
      company: "Google Developers Student Club (GDSC) KIIT",
      date: "Mar 12, 2024 - Present",
      desc: "• Participated as an Android Developer at Google Developers Student Club (GDSC), collaborating on innovative projects and working alongside talented developers passionate about technology. Also participated in hackathons, Study Jams, workshops, and community-driven events focused on mobile development and modern technologies.",
      skills: [
        "Leadership",
        "Teamwork",
        "Mobile Application Development",
        "Flutter",
        "XML",
        "Figma",
        "Android Studio",
      ],
    },
  
    {
      id: 5,
      role: "Open Source Contributor",
      company: "GitHub Open Source Contributor",
      date: "Mar 12, 2023 - Present",
      desc: "• I actively contribute to open-source projects, collaborating with developers worldwide while strengthening best practices in software development, system architecture, and collaborative engineering.",
      skills: [
        "Git",
        "GitHub",
        "Open Source",
        "Collaboration",
      ],
    },
  ],
  
  experience_0: {
    role: "Web Designer, Frontend Developer",
    company: "InnovaHogarTV",
    date: "Mar 1, 2021 - May 30, 2022",
    desc: "• Developed an e-commerce website using React JS, HTML, CSS, and JavaScript for a home products company. Focused on improving user experience by creating a highly interactive and responsive interface. Users could easily explore products and directly contact the company through intuitive navigation and optimized UI components.",
    skills: ["ReactJs", "NodeJs", "HTML", "CSS", "JavaScript"],
  },
  
  experience_1: {
    role: "Full-Stack Developer",
    company: "Snake Meta",
    date: "Nov 10, 2023 - Nov 25, 2024",
    desc: "• Enhanced user experiences using Flutter and Hive for offline-first functionality and local storage. Built JWT authentication and seamless REST API integrations using FastAPI, Flask, and Python. Exported the application to Android and iOS while maintaining updated dependencies and integrating SQLAlchemy with SQLite for database management. Implemented geolocation features using the Google Maps API.",
    skills: [
      "Python",
      "Flask",
      "FastAPI",
      "Flutter",
      "SQLAlchemy",
      "Hive",
      "Firebase",
      "Google Maps API",
    ],
  },
  
  experience_2: {
    role: "Mobile Developer, Software Debugger & Architecture",
    company: "Aktua",
    date: "Feb 13, 2024 - May 18, 2024",
    desc: "• Developed a PWA using Python, implementing Poetry, Uvicorn, Flask, and FastAPI. Managed PostgreSQL database queries with SQLAlchemy and designed high-level software architecture alongside UI prototypes using ProtoPie Cloud. Built secure and efficient backend endpoints with JWT authentication and optimized API performance by reducing unnecessary requests by 20%. Containerized the application using Docker to streamline deployment and automation workflows.",
    skills: [
      "Docker",
      "Python",
      "Flask",
      "SQLAlchemy",
      "FastAPI",
      "PostgreSQL",
      "ProtoPie",
      "Flutter",
      "JWT",
    ],
  },
  
  experience_3: {
    role: "Full-Stack Developer",
    company: "Bodytech and Athletic Gym",
    date: "Jan 15, 2024 - Feb 10, 2025",
    desc: "• Collaborated on the development and optimization of modern web interfaces focused on user experience and performance. Worked with React, TypeScript, and Tailwind CSS to build reusable components and responsive designs. Integrated frontend services with REST APIs and contributed to performance optimization, accessibility improvements, and visually engaging interfaces for fitness and wellness platforms.",
    skills: [
      "React",
      "TypeScript",
      "Tailwind CSS",
      "JavaScript",
      "REST API",
      "Figma",
      "Responsive Design",
    ],
  },
  
  experience_4: {
    role: "Android Developer",
    company: "Google Developers Student Club (GDSC) KIIT",
    date: "Mar 12, 2024 - Present",
    desc: "• Participated as an Android Developer at Google Developers Student Club (GDSC), collaborating on innovative projects and working alongside talented developers passionate about technology. Also participated in hackathons, Study Jams, workshops, and community-driven events focused on mobile development and modern technologies.",
    skills: [
      "Leadership",
      "Teamwork",
      "Mobile Application Development",
      "Flutter",
      "XML",
      "Figma",
      "Android Studio",
    ],
  },
  
  experience_5: {
    role: "Open Source Contributor",
    company: "GitHub Open Source Contributor",
    date: "Mar 12, 2023 - Present",
    desc: "• I actively contribute to open-source projects, collaborating with developers worldwide while strengthening best practices in software development, system architecture, and collaborative engineering.",
    skills: [
      "Git",
      "GitHub",
      "Open Source",
      "Collaboration",
    ],
  },
    experience_0_role: "Web Designer, Frontend Developer",
    experience_0_company: "InnovaHogarTV",
    experience_0_date: "Mar 1, 2021 - May 30, 2022",
    experience_0_desc: "• Developed an e-commerce website using React JS, HTML, CSS, and JavaScript for a home products company. Focused on improving user experience by creating a highly interactive and responsive interface. Users could easily explore products and directly contact the company through intuitive navigation and optimized UI components.",

    experience_1_role: "Full-Stack Developer",
    experience_1_company: "Snake Meta",
    experience_1_date: "Nov 10, 2023 - Nov 25, 2024",
    experience_1_desc: "• Enhanced user experiences using Flutter and Hive for offline-first functionality and local storage. Built JWT authentication and seamless REST API integrations using FastAPI, Flask, and Python. Exported the application to Android and iOS while maintaining updated dependencies and integrating SQLAlchemy with SQLite for database management. Implemented geolocation features using the Google Maps API.",

    experience_2_role: "Mobile Developer, Software Debugger & Architecture",
    experience_2_company: "Aktua",
    experience_2_date: "Feb 13, 2024 - May 18, 2024",
    experience_2_desc: "• Developed a PWA using Python, implementing Poetry, Uvicorn, Flask, and FastAPI. Managed PostgreSQL database queries with SQLAlchemy and designed high-level software architecture alongside UI prototypes using ProtoPie Cloud. Built secure and efficient backend endpoints with JWT authentication and optimized API performance by reducing unnecessary requests by 20%. Containerized the application using Docker to streamline deployment and automation workflows.",

    experience_3_role: "Full-Stack Developer",
    experience_3_company: "Bodytech and Athletic Gym",
    experience_3_date: "Jan 2024 - Dec 2025",
    experience_3_desc: "• Collaborated on the development and optimization of modern web interfaces focused on user experience and performance. Worked with React, TypeScript, and Tailwind CSS to build reusable components and responsive designs. Integrated frontend services with REST APIs and contributed to performance optimization, accessibility improvements, and visually engaging interfaces for fitness and wellness platforms.",

    experience_4_role: "Android Developer",
    experience_4_company: "Google Developers Student Club (GDSC) KIIT",
    experience_4_date: "Mar 12, 2024 - Present",
    experience_4_desc: "• Participated as an Android Developer at Google Developers Student Club (GDSC), collaborating on innovative projects and working alongside talented developers passionate about technology. Also participated in hackathons, Study Jams, workshops, and community-driven events focused on mobile development and modern technologies.",

    experience_5_role: "Open Source Contributor",
    experience_5_company: "GitHub Open Source Contributor",
    experience_5_date: "Mar 12, 2023 - Present",
    experience_5_desc: "• I actively contribute to open-source projects, collaborating with developers worldwide while strengthening best practices in software development, system architecture, and collaborative engineering.",
    education_school_0: "Rembrandt School",
    education_degree_0: "High School with Business Emphasis",
    education_desc_0: "I graduated from high school in 2021 from Rembrandt School in Bogotá, Colombia. During my time at this institution, I not only acquired academic knowledge but also cultivated fundamental values that have shaped my character and guided my actions. I learned the value of responsibility by fulfilling my school duties and actively participating in extracurricular activities. Honesty became a central pillar in my life by being transparent in my actions and relationships. Empathy flourished in me by understanding my peers' perspectives and providing support when needed.",
    education_school_1: "Minuto de Dios University Corporation San Juan Eudes Campus",
    education_degree_1: "Software Development Technologist",
    education_desc_1: "Technologist in training in Software Development at the Minuto de Dios University Corporation. During my time at the university, I have acquired a solid understanding of the fundamental principles of software development and advanced techniques for creating innovative applications. My focus on software development allowed me to reach the fifth semester of my academic program, providing me with a solid foundation in areas such as programming, database design, and web and mobile application development.",
    education_school_2: "Language Center - Unillanos",
    education_degree_2: "English Advanced C1",
    education_desc_2: "During my time at the Language Center - Unillanos, I am completing the English Advanced C1 program, reaching the C1 level in English. This experience has provided me with advanced skills in listening, speaking, reading, and writing in English. I am capable of effectively communicating in various academic, professional, and social settings in English.",
    education_title: "Education",
    education_desc: "My educational journey has been a path of self-exploration and personal development, where I have had the opportunity to discover and grow in various aspects. Below is a detailed account of my educational background:",
    grade_label: "Status",
    skills_label: "Skills",
    skill_0_0: "Effective Communication",
    skill_0_1: "Empathy",
    skill_0_2: "Conflict Resolution",
    skill_0_3: "Negotiation Skills",
    skill_0_4: "Emotion Management",
    skill_1_0: "Project Leadership",
    skill_1_1: "Database Design",
    skill_1_2: "Web Application Development",
    skill_1_3: "Problem Solving",
    skill_1_4: "Teamwork",
    skill_2_0: "Speaking",
    skill_2_1: "Writing",
    skill_2_2: "Reading",
    skill_2_3: "Listening",
    skill_2_4: "Grammar",
    // Add more translations as needed
    projects_title: "Projects",
    projects_desc: "I have been involved in a wide range of projects, from creating web applications to developing mobile apps. Here are some examples of what I have done.",
    all: "All",
    web_apps: "Web Apps",
    android_apps: "Mobile Apps",
    machine_learning: "Machine Learning",
    go_to_code: "Go to Code",
    go_to_live_app: "Go to Live App",
    members: "Members",
    language: "Language",
    spanish: "Spanish",
    english: "English",
    github_profile: "Github Profile",
    project_details: {
      0: {
        title: "AITEC - Corporate Website",
        date: "Jan 2026 - Apr 2026",
        description: "I developed the complete corporate website for AITEC, a leading company in environmental solutions. The project included responsive design, SEO optimization, contact form integration, and informative sections about services and products. I implemented a modern, professional experience aligned with the brand identity.",
        tags: ["HTML", "CSS", "JavaScript", "Next.js", "React"],
      },
      1: {
        title: "Automotive Cardex Inventory",
        date: "Apr 2026 - May 2026",
        description: "Automotive inventory management system developed with modern technologies. Allows complete control of parts, spare parts, and vehicles with registration, advanced search, reports, and stock tracking functionalities. Implements user authentication, roles, and permissions for secure inventory management. Includes dashboard with real-time metrics and low stock alerts.",
        tags: ["React", "Node.js", "Express", "MongoDB", "Material UI", "JWT"],
      },
      2: {
        title: "Snake Meta",
        date: "Nov 2023 - Nov 2024",
        description: "The Mobile Application is planned to be launched on Playstore in November 2024. This project proposes the 'Development of a Mobile Application to prevent, inform, and preserve the different species of snakes in Meta'. It keeps a record of all the snakes in the Department through an API with their Taxonomy, Data, Information, and Georeferencing. It has the Google Maps API to georeference the snake in the user room database. Made with Flutter in MVVM Architecture and Live Data.",
        tags: ["Python", "FastAPI", "Flutter", "SQLAlchemy", "Hive", "Firebase", "Google Maps API"],
      },
      3: {
        title: "Aktua",
        date: "Feb 2024 - May 2024",
        description: "Developed a PWA (Progressive Web Application) in a Scrum framework with the aim of creating and fostering united, safe, and collaborative neighborhood communities. Used Python to connect with FastAPI, Uvicorn, Poetry services, and SqlAlchemy for database connection with PostgreSQL. Created services for Posts, Comments, and Ratings for users and Dockerized the project to make it cross-platform. With Flutter, we created the application for mobile devices, making it compatible with iOS and Android.",
        tags: ["Docker", "Python", "SQLAlchemy", "FastAPI", "PostgreSQL", "ProtoPie", "Flutter", "JWT"],
      },
      4: {
        title: "UEFA Champions League Bracket",
        date: "May 2026 - May 2026",
        description: "Interactive UEFA Champions League prediction bracket. It lets users drag teams between rounds and simply choose who they think wins each matchup until reaching the champion.",
        tags: ["JavaScript", "React", "HTML", "CSS", "API Integration"],
      },
      5: {
        title: "Landing Page Unillanos",
        date: "May 2024 - Jun 2024",
        description: "Designed and developed a Landing Page with Astro, Tailwind CSS, and Material UI, it is a web page dedicated to acknowledgments for our graduation of study companions. I implemented a creative design where you can see the acknowledgment speech in several languages, English and Spanish, and I also implemented a photo carousel of the students who will graduate. I followed up on the landing page to improve the effectiveness and warmth of the project.",
        tags: ["Astro", "HTML", "CSS", "JavaScript", "Tailwind CSS", "Material UI"],
      },
      6: {
        title: "Brain Tumor Detection",
        date: "Jan 2023 - Mar 2023",
        description: "Supported a Web Application which preprocessed and augmented the dataset to improve model accuracy, trained the model, improved the API using the model and Python, and used the React web application for the project interface. Achievements: Achieved 99.2% accuracy in accurately detecting brain tumors from medical images.",
        tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
      },
    },
  },
  es: {
    studio: studioEs,
    about: "Acerca",
    skills: "Habilidades",
    experience: "Experiencia",
    projects: "Proyectos",
    education: "Educación",
    contact: "Contacto",
    contact_desc: "No dudes en comunicarte conmigo si tienes alguna pregunta u oportunidad.",
    contact_info_title: "Construyamos algo juntos",
    contact_info_text: "Abierto a roles full-time, proyectos freelance y colaboraciones interesantes. Respondo en menos de 24 horas.",
    contact_available: "Disponible para trabajar",
    contact_connect: "Conecta conmigo",
    contact_form_title: "Envíame un e-mail",
    contact_email_placeholder: "tu@email.com",
    contact_email_error: "Por favor ingresa un correo válido.",
    contact_name_label: "Nombre",
    contact_name_placeholder: "Tu nombre completo",
    contact_subject_label: "Asunto",
    contact_subject_placeholder: "¿En qué puedo ayudarte?",
    contact_message_label: "Mensaje",
    contact_message_placeholder: "Cuéntame sobre tu proyecto...",
    contact_sending: "Enviando...",
    contact_send: "Enviar mensaje",
    contact_success: "Correo electrónico enviado correctamente.",
    hi: "Hola, soy",
    i_am_a: "Soy un",
    view_cv: "Ver Hoja de Vida",
    // Bio translations
    bio_description: "Soy una persona motivada y versátil, siempre dispuesta a enfrentar nuevos desafíos. Apasionado por el aprendizaje, me dedico a ofrecer resultados de alta calidad. Poseo una actitud positiva y una mentalidad de crecimiento, lo que me impulsa constantemente a mejorar y desarrollarme tanto personal como profesionalmente.",
    // Skills translations
    technical_skills: "Habilidades Técnicas",
    soft_skills: "Habilidades Blandas",
    skill_desc: "Estas son algunas de las habilidades en las que he estado trabajando y desarrollándome durante los últimos 3 años.",
    skill_1: "Capacidad de aprender nuevos lenguajes de forma rápida y eficaz.",
    skill_2: "Experiencia con herramientas de desarrollo frameworks, APIs y librerías.",
    skill_3: "Comprender la arquitectura de software y su diseño de manera efectiva.",
    skill_4: "Capacidad de entender y utilizar APIs de terceros.",
    skill_5: "Conocimientos de base de datos y uso de diferentes herramientas.",
    soft_skill_1: "Capacidad de comunicación efectiva y clara.",
    soft_skill_2: "Capacidad de adaptación a cambios y solución de problemas.",
    soft_skill_3: "Creatividad y habilidad de pensar en soluciones innovadoras y efectivas.",
    soft_skill_4: "Facilidad para trabajar en equipo y liderar equipos de trabajo.",
    soft_skill_5: "Autogestión y capacidad de trabajar de forma autónoma.",
    // Frameworks translations
    frameworks_title: "Tecnologías",
    frameworks_desc: "Estas son algunas de las tecnologías, frameworks y lenguajes de programación en los que he estado trabajando y desarrollándome durante los últimos 3 años.",
    languages: "Lenguajes",
    frontend: "Frontend",
    backend: "Backend",
    databases: "Bases de Datos",
    mobile: "Móvil",
    ai: "IA & Automatización",
    devops: "DevOps & Cloud",
    tools: "Herramientas",
    // Roles translations
    full_stack_developer: "Desarrollador Full-Stack",
    mobile_developer: "Desarrollador Móvil",
    ui_ux_designer: "Diseñador UI/UX",
    ai_developer: "Desarrollador IA",
    // Experience translations
    experience_title: "Experiencia",
    experience_desc: "Soy Tecnólogo en Desarrollo de Software, con una sólida base académica y un gran interés en aplicar mis conocimientos en el desarrollo de soluciones tecnológicas innovadoras. Estoy iniciando mi trayectoria profesional y busco oportunidades para contribuir a proyectos prácticos, donde pueda continuar aprendiendo y desarrollándome mientras aporto valor con mis habilidades en programación, diseño de software y resolución de problemas.",
    experience_0: {
      role: "Diseñador Web, Desarrollador Frontend",
      company: "InnovaHogarTV",
      date: "1 Mar, 2021 - 30 May, 2022",
      desc: "• Desarrollé un sitio web de comercio electrónico utilizando tecnologías como React JS, HTML, CSS y JavaScript para una empresa dedicada a la venta de productos para el hogar. En este proyecto, me enfoqué en mejorar la experiencia del usuario mediante la creación de una página altamente interactiva. Los usuarios tienen la capacidad de explorar fácilmente los productos ofrecidos gracias a una interfaz intuitiva y responsive. Además, implementé funcionalidades que permiten a los usuarios contactar directamente con la empresa, mejorando la comunicación y la experiencia del cliente.",
      skills: [
        "ReactJs",
        "NodeJs",
        "HTML",
        "CSS",
        "JavaScript",
      ],
    },
    
    experience_1: {
      role: "Desarrollador Fullstack",
      company: "Snake Meta",
      date: "10 Nov, 2023 - 25 Nov, 2024",
      desc: "• Mejoré la experiencia de usuario utilizando Flutter y Hive para almacenamiento local y funcionalidades offline. Implementé autenticación JWT y una integración eficiente de APIs REST utilizando FastAPI, Flask y Python. La aplicación fue exportada a Android e iOS, manteniendo dependencias actualizadas e integrando SQLAlchemy con SQLite para la gestión de bases de datos. Además, implementé georreferenciación utilizando Google Maps API.",
      skills: [
        "Python",
        "Flask",
        "FastAPI",
        "Flutter",
        "SQLAlchemy",
        "Hive",
        "Firebase",
        "Google Maps API",
      ],
    },
    
    experience_2: {
      role: "Desarrollador Móvil, Depuración y Arquitectura de Software",
      company: "Aktua",
      date: "13 Feb, 2024 - 18 May, 2024",
      desc: "• Desarrollé una PWA utilizando Python, implementando Poetry, Uvicorn, Flask y FastAPI. Gestioné consultas PostgreSQL mediante SQLAlchemy y diseñé arquitectura de alto nivel junto a interfaces en ProtoPie Cloud. Implementé autenticación JWT para seguridad y optimicé el rendimiento reduciendo llamadas a la API en un 20%. Además, dockericé la aplicación para facilitar despliegues y automatización de procesos.",
      skills: [
        "Docker",
        "Python",
        "Flask",
        "SQLAlchemy",
        "FastAPI",
        "PostgreSQL",
        "ProtoPie",
        "Flutter",
        "JWT",
      ],
    },
    
    experience_3: {
      role: "Desarrollador Full-Stack",
      company: "BodyTech y Athletic Gym",
      date: "27 Mar, 2025 - 19 Ene, 2026",
      desc: "• Desarrollé aplicaciones web con PHP (Phalcon) y React, creando APIs REST, autenticación RBAC y módulos internos seguros. Integré PQRS con web, WhatsApp Business API y correo, automaticé procesos clave y optimicé consultas backend, reduciendo tiempos de carga en más del 30%.",
      skills: [
        "React",
        "PHP",
        "Phalcon",
        "REST API",
        "RBAC",
        "MySQL",
        "AWS",
        "Docker",
        "Git",
        "Jira",
        "JavaScript",
      ],
    },
    
    experience_4: {
      role: "Desarrollador Android",
      company: "Google Developers Student Club (GDSC) KIIT",
      date: "12 Mar, 2024",
      desc: "• Como desarrollador Android participé activamente en Google Developers Student Club (GDSC), colaborando en proyectos tecnológicos y trabajando junto a desarrolladores talentosos. También participé en eventos como hackathons, Study Jams y workshops enfocados en desarrollo móvil y tecnologías modernas.",
      skills: [
        "Leadership",
        "Teamwork",
        "Mobile Application Development",
        "Flutter",
        "XML",
        "Figma",
        "Android Studio",
      ],
    },
    
    experience_5: {
      role: "Contribuidor de Código Abierto",
      company: "GitHub Open Source Contributor",
      date: "12 Mar, 2023 - Present",
      desc: "• Contribuyo actualmente a proyectos de código abierto, colaborando con desarrolladores de distintas partes del mundo mientras fortalezco buenas prácticas de desarrollo, arquitectura de software y trabajo colaborativo.",
      skills: [
        "Git",
        "GitHub",
        "Open Source",
        "Collaboration",
      ],
    },
    experience_0_role: "Diseñador Web, Desarrollador Frontend",
    experience_0_company: "InnovaHogarTV",
    experience_0_date: "1 Mar, 2021 - 30 May, 2022",
    experience_0_desc: "• Desarrollé un sitio web de comercio electrónico utilizando React JS, HTML, CSS y JavaScript para una empresa dedicada a productos para el hogar. Me enfoqué en mejorar la experiencia del usuario mediante una interfaz altamente interactiva y responsive. Los usuarios podían explorar productos fácilmente y contactar directamente con la empresa gracias a una navegación intuitiva y componentes optimizados.",
      
    experience_1_role: "Desarrollador Fullstack",
    experience_1_company: "Snake Meta",
    experience_1_date: "10 Nov, 2023 - 25 Nov, 2024",
    experience_1_desc: "• Mejoré la experiencia de usuario utilizando Flutter y Hive para funcionalidades offline y almacenamiento local. Implementé autenticación JWT e integración eficiente de APIs REST utilizando FastAPI, Flask y Python. La aplicación fue exportada a Android e iOS, manteniendo dependencias actualizadas e integrando SQLAlchemy con SQLite para la gestión de bases de datos. Además, implementé funcionalidades de geolocalización utilizando Google Maps API.",
      
    experience_2_role: "Desarrollador Móvil, Depuración y Arquitectura de Software",
    experience_2_company: "Aktua",
    experience_2_date: "13 Feb, 2024 - 18 May, 2024",
    experience_2_desc: "• Desarrollé una PWA utilizando Python, implementando Poetry, Uvicorn, Flask y FastAPI. Gestioné consultas a PostgreSQL mediante SQLAlchemy y diseñé arquitectura de software de alto nivel junto a prototipos UI utilizando ProtoPie Cloud. Construí endpoints seguros y eficientes con autenticación JWT y optimicé el rendimiento reduciendo llamadas innecesarias a la API en un 20%. Además, dockericé la aplicación para facilitar despliegues y automatización de procesos.",
      
    experience_3_role: "Desarrollador Full-Stack",
    experience_3_company: "BodyTech y Athletic Gym",
    experience_3_date: "27 Mar, 2025 - 19 Ene, 2026",
    experience_3_desc: "• Desarrollé aplicaciones web con PHP (Phalcon) y React, creando APIs REST, autenticación RBAC y módulos internos seguros. Integré PQRS con web, WhatsApp Business API y correo, automaticé procesos clave y optimicé consultas backend, reduciendo tiempos de carga en más del 30%.",

    experience_4_role: "Desarrollador Android",
    experience_4_company: "Google Developers Student Club (GDSC) KIIT",
    experience_4_date: "12 Mar, 2024 - Presente",
    experience_4_desc: "• Participé como desarrollador Android en Google Developers Student Club (GDSC), colaborando en proyectos innovadores junto a desarrolladores apasionados por la tecnología. También participé en hackathons, Study Jams, workshops y eventos enfocados en desarrollo móvil y tecnologías modernas.",
      
    experience_5_role: "Contribuidor de Código Abierto",
    experience_5_company: "GitHub Open Source Contributor",
    experience_5_date: "12 Mar, 2023 - Presente",
    experience_5_desc: "• Contribuyo actualmente a proyectos de código abierto, colaborando con desarrolladores de diferentes partes del mundo mientras fortalezco buenas prácticas de desarrollo de software, arquitectura de sistemas y trabajo colaborativo.",
    // Education translations
    education_school_0: "Colegio Rembrandt",
    education_degree_0: "Bachillerato con Enfasís Empresarial",
    education_desc_0: "Me gradué de bachillerato en 2021 del colegio Rembrandt en Bogotá, Colombia. Durante mi tiempo en esta institución, no solo adquirí conocimientos académicos, sino que también cultivé valores fundamentales que han moldeado mi carácter y guiado mis acciones. Aprendí el valor de la responsabilidad al cumplir con mis deberes escolares y participar activamente en actividades extracurriculares. La honestidad se convirtió en un pilar central en mi vida al ser transparente en mis acciones y relaciones. La empatía floreció en mí al entender las perspectivas de mis compañeros y brindar apoyo cuando era necesario.",
    education_school_1: "Corporación Universitaria Minuto de Dios sede San Juan Eudes",
    education_degree_1: "Tecnólogo En Desarollo de Software",
    education_desc_1: "Tecnólogo en formación en Desarrollo de Software en la Corporación Universitaria Minuto de Dios. Durante mi tiempo en la universidad, he adquirido una sólida comprensión de los principios fundamentales del desarrollo de software y técnicas avanzadas para la creación de aplicaciones innovadoras. Mi enfoque en el desarrollo de software me permitió alcanzar el quinto semestre de mi programa académico, lo que me brindó una base sólida en áreas como programación, diseño de bases de datos y desarrollo de aplicaciones web y móviles.",
    education_school_2: "Centro de Idiomas - Unillanos",
    education_degree_2: "English Advanced C1",
    education_desc_2: "Durante mi tiempo en el Centro de Idiomas - Unillanos, estoy completando el programa de English Advanced C1, alcanzando el nivel C1 en inglés. Esta experiencia me ha proporcionado habilidades avanzadas en comprensión auditiva, expresión oral, lectura y escritura en inglés. Estoy capacitado para comunicarme efectivamente en diversos entornos académicos, profesionales y sociales en inglés.",
    education_title: "Educación",
    education_desc: "Mi trayectoria educativa ha sido un viaje de autoexploración y desarrollo personal, donde he tenido la oportunidad de descubrir y crecer en diversos aspectos. A continuación, se detalla mi formación educativa:",
    grade_label: "Estado",
    skills_label: "Habilidades",
    skill_0_0: "Comunicación Efectiva",
    skill_0_1: "Empatía",
    skill_0_2: "Resolución de Conflictos",
    skill_0_3: "Habilidades de Negociación",
    skill_0_4: "Gestión de Emociones",
    skill_1_0: "Liderazgo en Proyectos",
    skill_1_1: "Diseño de Bases de Datos",
    skill_1_2: "Desarollo de Aplicaciones Web",
    skill_1_3: "Resolución de Problemas",
    skill_1_4: "Trabajo en Equipo",
    skill_2_0: "Speaking",
    skill_2_1: "Writing",
    skill_2_2: "Reading",
    skill_2_3: "Listening",
    skill_2_4: "Grammar",
    // Add more translations as needed
    projects_title: "Proyectos",
    projects_desc: "He estado involucrado en una gran cantidad de proyectos, desde la creación de aplicaciones web hasta el desarrollo de apps para Android. Aquí tienes algunos ejemplos de lo que he hecho.",
    all: "Todos",
    web_apps: "Aplicaciones Web",
    android_apps: "Aplicaciones Móviles",
    machine_learning: "Aprendizaje Automático",
    go_to_code: "Ir al Código",
    go_to_live_app: "Ir a la App en Vivo",
    members: "Miembros",
    language: "Idioma",
    spanish: "Español",
    english: "Inglés",
    github_profile: "Perfil Github",
    project_details: {
      0: {
        title: "AITEC - Sitio Web Corporativo",
        date: "Ene 2026 - Abr 2026",
        description: "Desarrollé el sitio web corporativo completo para AITEC, una empresa líder en soluciones ambientales. El proyecto incluyó diseño responsivo, optimización SEO, integración de formularios de contacto y secciones informativas sobre servicios y productos. Implementé una experiencia moderna y profesional alineada con la identidad de la marca.",
        tags: ["HTML", "CSS", "JavaScript", "Next.js", "React"],
      },
      1: {
        title: "Inventario Cardex Automotriz",
        date: "Abr 2026 - May 2026",
        description: "Sistema de gestión de inventario automotriz desarrollado con tecnologías modernas. Permite el control completo de piezas, repuestos y vehículos con funcionalidades de registro, búsqueda avanzada, reportes y seguimiento de stock. Implementa autenticación de usuarios, roles y permisos para gestión segura del inventario. Incluye dashboard con métricas en tiempo real y alertas de stock bajo.",
        tags: ["React", "Node.js", "Express", "MongoDB", "Material UI", "JWT"],
      },
      2: {
        title: "Snake Meta",
        date: "Nov 2023 - Nov 2024",
        description: "La aplicación móvil está planeada para ser lanzada en Playstore en noviembre de 2024. Este proyecto propone el 'Desarrollo de una aplicación móvil para prevenir, informar y preservar las diferentes especies de serpientes en Meta'. Mantiene un registro de todas las serpientes en el Departamento a través de una API con su taxonomía, datos, información y georreferenciación. Tiene la API de Google Maps para georreferenciar la serpiente en la base de datos de la sala del usuario. Hecho con Flutter en arquitectura MVVM y Live Data.",
        tags: ["Python", "FastAPI", "Flutter", "SQLAlchemy", "Hive", "Firebase", "Google Maps API"],
      },
      3: {
        title: "Aktua",
        date: "Feb 2024 - May 2024",
        description: "Desarrollé una PWA (Aplicación Web Progresiva) en un marco Scrum con el objetivo de crear y fomentar comunidades de vecindarios unidas, seguras y colaborativas. Utilicé Python para conectarme con los servicios de FastAPI, Uvicorn, Poetry y SqlAlchemy para la conexión de la base de datos con PostgreSQL. Creé servicios para publicaciones, comentarios y calificaciones de usuarios y Dockericé el proyecto para hacerlo multiplataforma. Con Flutter, creamos la aplicación para dispositivos móviles, haciéndola compatible con iOS y Android.",
        tags: ["Docker", "Python", "SQLAlchemy", "FastAPI", "PostgreSQL", "ProtoPie", "Flutter", "JWT"],
      },
      4: {
        title: "UEFA Champions League Bracket",
        date: "May 2026 - May 2026",
        description: "Pronóstico interactivo para la UEFA Champions League. Permite arrastrar equipos entre rondas y armar, de forma simple, quién crees que gana cada cruce hasta llegar al campeón.",
        tags: ["JavaScript", "React", "HTML", "CSS", "API Integration"],
      },
      5: {
        title: "Landing Page Unillanos",
        date: "May 2024 - Jun 2024",
        description: "Diseñé y desarrollé una página de aterrizaje con Astro, Tailwind CSS y Material UI, es una página web dedicada a los agradecimientos por nuestra graduación de compañeros de estudio. Implementé un diseño creativo donde se puede ver el discurso de agradecimiento en varios idiomas, inglés y español, y también implementé un carrusel de fotos de los estudiantes que se graduarán. Hice un seguimiento de la página de aterrizaje para mejorar la efectividad y calidez del proyecto.",
        tags: ["Astro", "HTML", "CSS", "JavaScript", "Tailwind CSS", "Material UI"],
      },
      6: {
        title: "Detección de Tumores Cerebrales",
        date: "Ene 2023 - Mar 2023",
        description: "Realicé una aplicación web que preprocesó y aumentó el conjunto de datos para mejorar la precisión del modelo, entrené el modelo, mejoré la API utilizando el modelo y Python, y utilicé la aplicación web React para la interfaz del proyecto. Logros: Logré una precisión del 99.2% en la detección precisa de tumores cerebrales a partir de imágenes médicas.",
        tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
      },
    },
  },
};
